// shared
import useCommonStore from 'store/useCommonStore';
import { PlatformCode } from 'type/common';
import { setCategoryColor } from 'utils/colorType';
// styled
import { TableCellWrapper, TagInner } from './style';
// type
import type { ICell } from './type';
import { CoreTag } from '@featuring-corp/components';
import { getTagColorType } from 'src/components/report/report-profile/util';

export interface ICategoryCell extends ICell {
	categories?: (string | null)[];
	platform_code?: PlatformCode;
}

const Category = ({
	_width,
	_margin,
	_padding,
	categories = [],
	platform_code,
}: ICategoryCell) => {
	const { platform } = useCommonStore();

	return (
		<TableCellWrapper
			_width={_width}
			flex="start"
			_margin={_margin}
			_padding={_padding ?? '0 0 0 16px'}
		>
			<TagInner>
				{categories.map((item, idx) => {
					if (item === null || item.trim() === '') return;

					return (
						// <CoreTag
						// 	key={idx}
						// 	tag_type="text"
						// 	color_type={setCategoryColor(item, platform_code ?? platform.code)}
						// 	value={item}
						// />
						<CoreTag key={idx} tagType={getTagColorType(item)} text={item} />
					);
				})}
			</TagInner>
		</TableCellWrapper>
	);
};

export default Category;
